import { ErrorMessages, STATUS_CODE } from 'constants/errors';
import { CredentialErrors } from '../constants/errors';
import { ErrorResponseType } from 'types/request';

export const getErrorMessage = (error: string) => {
  const isCredentialsError = CredentialErrors.includes(error);

  if (isCredentialsError) {
    return ErrorMessages.AUTH.INVALID_DATA;
  }

  return ErrorMessages.COMMON.UNKNOWN;
};

export const checkIsLimitError = (error: ErrorResponseType) => {
  return error?.status === STATUS_CODE.TOO_MANY_REQUESTS;
};
